// DevToolsDetector.js

/**
 * 1. Timing Check (Reliant on debugger pause)
 * Exploits the performance difference when the 'debugger' statement is encountered.
 * Returns the time elapsed. A large time suggests a pause.
 */
export const runTimingCheck = () => {
  const start = performance.now();
  
  try {
    // Using Function constructor to hold the debugger statement
    new Function('debugger')(); 
  } catch (e) {
    // Ignore errors
  }
  
  const end = performance.now();
  return end - start;
};

/**
 * 2. Window Size Check (Relies on DevTools being docked)
 * Compares the inner and outer dimensions of the window.
 * A significant difference suggests a docked panel (like DevTools).
 */
export const runSizeCheck = () => {
    // A minimum difference in pixels considered to be DevTools
    const MIN_DIFF = 150; 
    
    const widthDiff = window.outerWidth - window.innerWidth;
    const heightDiff = window.outerHeight - window.innerHeight;

    // Check if the difference is large, indicating a docked DevTools panel
    // or if the outer dimensions are unusually large/small compared to inner.
    return widthDiff > MIN_DIFF || heightDiff > MIN_DIFF;
};